import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import ExaminationWrapper from '../../../../Examination/components/Assessment/AssessmentWrapper'
import FollowUpBookingCapture from '../../../../Examination/components/follow-up-booking-capture'
import RefferalLetterCapture from '../../../../Examination/components/referral-letter-capture'
import SickNoteCapture from '../../../../Examination/components/sick-note-capture'
import ClinicalNotes from '../../../../Examination/components/Clinical Notes/ClinicalNotesTool'
import NurseScreeningMedicalHistory from '../../../../Bookings/components/Examination Components/MedicalHistoryView.js'
import { Row, Col, Input, Button, Spin } from 'antd'

const ModalContent = memo(({ 
  assessmentModalOpen,
  followUpModalOpen,
  sickNoteModalOpen,
  referralModalOpen,
  clinicalNotesModalOpen,
  medicalHistoryModalOpen,
  setAssessmentModalOpen,
  setFollowUpModalOpen,
  setReferralModalOpen,
  setSickNoteModalOpen,
  setClinicalNotesModalOpen,
  setMedicalHistoryModalOpen,
  userData,
  token,
  confirmationCode,
  setConfirmationCode,
  submitDisabled,
  form,
  handleSubmit,
  handleLoginPhoneCode,
  isConfirmationModal
}) => {
  // Render Assessment content
  if (assessmentModalOpen) {
    return (
      <>
        <FontAwesomeIcon
          onClick={() => setAssessmentModalOpen(false)}
          style={{ float: 'right', cursor: 'pointer' }}
          icon={faXmarkCircle}
          color={token.colorError}
          fontSize={26}
        />
        <ExaminationWrapper userRef={userData._id} readOnly={true} />
      </>
    )
  }

  // Render Follow-up content
  if (followUpModalOpen) {
    return <FollowUpBookingCapture userRef={userData._id} setModalOpen={setFollowUpModalOpen} />
  }
  
  // Render Referral content
  if (referralModalOpen) {
    return <RefferalLetterCapture setModalOpen={setReferralModalOpen} />
  }
  
  // Render Sick Note content
  if (sickNoteModalOpen) {
    return <SickNoteCapture setModalOpen={setSickNoteModalOpen} patient={userData} />
  }
  
  // Render Clinical Notes content
  if (clinicalNotesModalOpen) {
    return <ClinicalNotes noBooking userRef={userData._id} setModalOpen={setClinicalNotesModalOpen} />
  }
  
  // Render Medical History content
  if (medicalHistoryModalOpen) {
    return <NurseScreeningMedicalHistory noBooking setModalOpen={setMedicalHistoryModalOpen} userRef={userData._id} />
  }

  // Render One-time Pin content
  if (isConfirmationModal) {
    return (
      <>
        <Row justify='center'>
          <Col>
            Please provide the One-time Pin sent to your Cellphone
            <Input
              value={confirmationCode}
              onChange={(e) => {
                if (/^[0-9]*$/g.test(e.target.value) === true) {
                  setConfirmationCode(e.target.value)
                }
              }}
            />
          </Col>
        </Row>
        <Row justify='space-between' style={{ marginTop: 20 }}>
          <Col>
            <Button
              disabled={submitDisabled}
              onClick={() => {
                const data = form.getFieldsValue()
                handleSubmit(data)
              }}
              type='primary'
            >
              Resend Code
            </Button>
          </Col>
          <Col>
            <Button
              disabled={submitDisabled}
              onClick={() => handleLoginPhoneCode()}
              type='primary'
              style={{ backgroundColor: token.colorSuccess }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </>
    )
  }

  return null
})

ModalContent.propTypes = {
  assessmentModalOpen: PropTypes.bool,
  followUpModalOpen: PropTypes.bool,
  sickNoteModalOpen: PropTypes.bool,
  referralModalOpen: PropTypes.bool,
  clinicalNotesModalOpen: PropTypes.bool,
  medicalHistoryModalOpen: PropTypes.bool,
  setAssessmentModalOpen: PropTypes.func,
  setFollowUpModalOpen: PropTypes.func,
  setReferralModalOpen: PropTypes.func,
  setSickNoteModalOpen: PropTypes.func,
  setClinicalNotesModalOpen: PropTypes.func,
  setMedicalHistoryModalOpen: PropTypes.func,
  userData: PropTypes.object,
  token: PropTypes.object,
  confirmationCode: PropTypes.string,
  setConfirmationCode: PropTypes.func,
  submitDisabled: PropTypes.bool,
  form: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleLoginPhoneCode: PropTypes.func,
  isConfirmationModal: PropTypes.bool
}

// Set default props to prevent errors when some props are not provided
ModalContent.defaultProps = {
  assessmentModalOpen: false,
  followUpModalOpen: false,
  sickNoteModalOpen: false,
  referralModalOpen: false,
  clinicalNotesModalOpen: false,
  medicalHistoryModalOpen: false,
  isConfirmationModal: false,
  userData: {},
  token: {}
}

ModalContent.displayName = 'ModalContent'

export default ModalContent 